module.exports = __webpack_public_path__ + "img/Nyromantikk_Tanker_i_tida_Nietzsche.9d98b4f0.jpg";